<header class="header">
  <a routerLink="/" class="header__logo">
    <h2 class="header__name">
      <span class="logo__name-part">Zofia Pilich</span>
      <span class="logo__name-part">Artist based in Warsaw, Poland</span>
    </h2>
  </a>
</header>
